import { fetch } from '../hooks/use-fetch';

export const getSequence = async (auth) => {
  return await fetch.get('/getSequence', {
    params: {
      clientId: auth.activeUser ? auth.activeUser.clientId : ''
    }
  }, auth);
}